<template>
    <div>
      
      <div class="filters-table" v-if="filters">
        <div class="filter-container" v-for="filter in visibleFilters" v-bind:key="filter.Description">
            <div class="filter-header" v-html="filter.Description"></div>
            <div class="filter-values">
              <DxSelectBox
                v-if="filter.Data"
                :data-source="filter.Data"
                display-expr="description"
                value-expr="value"                        
                v-model="filter.Value"
                :read-only="filter.Locked"
              />
              <input v-else type="text" class="form-control" v-model="filter.Value" :readonly="filter.Locked" :disabled="filter.Locked" />       
            </div>
        </div>
        <div>
          <div>&nbsp;</div>
          <div>
            <button type="button" class="btn btn-outline-info" @click.prevent="(e) => apply(e)">Apply</button> 
          </div>
        </div>
        <div>
          <div>&nbsp;</div>
          <div>
            <button type="button" class="btn btn-outline-info" @click.prevent="(e) => clear(e)">Clear</button> 
          </div>
        </div>
      </div>
      
    </div>
  </template>
  <script>

  import DxSelectBox from 'devextreme-vue/select-box';
      
  export default {
    name: "Filters",
    components: { 
      DxSelectBox
    },
    props: {
      value: {
          default: () => {}
      },
      onValueChanged: {
          type: Function,
          default: () => function() {}
      }
    },
    computed: {
      buildFilters() {
        var filters = {};

        if(this.filters) {

          //console.log(this.filters);

          this.filters.forEach(filter => {
            filters[filter.Key] = filter.Value;
          });
        }

        return filters;
        //return { co2Emissions: this.co2Emissions, fuelType: this.fuelType, 
        //  transmission: this.transmission, bodyStyle: this.bodyStyle, doors: this.doors };
      },
      visibleFilters() {
        return this.filters.filter(f => f.Visible );
      }
    },
    data() {
      return {
          co2: 0,
          fuelType: "",
          transmission: "",
          bodyStyle: "",
          doors: 0,
          filters: []
      };
    },
    created: function() {
        
        var filterValues = JSON.parse(JSON.stringify(this.value));

        var _this = this;
        this.getFilters((data) => {   
          _this.filters = data;
        
          if(filterValues) {
            Object.keys(filterValues).forEach(key => {
              var filter = _this.filters.find(f => f.Key == key);
              if(filter) {
                filter.Value = filterValues[key];
              }
            });
          }
        }); 
                   
        this.onValueChanged(this.buildFilters);
    },
    methods: {
      apply(e) {
        this.onValueChanged(this.buildFilters);
      },
      clear(e) {
        this.filters.forEach(filter => {
          if(!filter.Locked)
            filter.Value = null;
        });
        this.apply(e);
      }
    }
  };
  </script>
  <style>
   .filters-table {
    display: inline-table;
   }
   .filters-table > div {
    height: 60px; float: left;
    padding-right: 5px;
   }
   .filter-header {
    font-weight: bold;
   }
   .filter-values {
    width:150px;
   }
   .filter-values .dx-texteditor.dx-editor-outlined {
    background-color: white;
   }
   div.dx-texteditor-input-container > div.dx-placeholder {
    margin-top: -7px;
   }
  </style>
  